export default __webpack_public_path__ + "static/media/YOOZScan2Pay-Image-to-resize-and-reformat_2.d9bae344.png";